
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.39 11.677a1.135 1.135 0 01-1.606 0L.803 8.695a1.135 1.135 0 010-1.605l2.98-2.981A1.135 1.135 0 115.39 5.714L4.346 6.757h9.834a1.135 1.135 0 010 2.27H4.346l1.043 1.044a1.135 1.135 0 010 1.606z","fill":"currentColor"}})])
          )
        }
      }
    